import React, { useState, useEffect, useRef, Children } from 'react'
import { Modal, ModalBody, Text, Input, Button, Flex, InjectedModalProps, Box } from '@pancakeswap/uikit'
import styled, { useTheme } from 'styled-components'

import { useWeb3React } from '@web3-react/core'
import abi from '../../../abi/erc20.abi.json'
import lotteryAbi from '../../../abi/lottery.abi.json'
import { ethers } from 'ethers'

const StyledRoundedDigit = styled(Text)`
  font-size: 14px;
  font-weight: 700;
  color: white;
  background: ${({ theme }) => (theme.isDark ? '#141E31' : '#8791A5')};
  width: 36px;
  height: 36px;
  text-align: center;
  line-height: 36px;
  border-radius: 120px;
`

const StyledSoftText = styled(Text)`
  color: ${({ theme }) => theme.colors.softTextColor};
`

const StyledHr = styled.hr`
  border-color: ${({ theme }) => theme.colors.hrColor};
  border-size: 1px;
  border-style: solid;
  width: 90%;
  margin-top: 20px;
`

const arrayToBitmap = (arr) => {
  let bitmap = ethers.BigNumber.from(0)
  const sortedArr = [...arr].sort((a, b) => a - b)
  for (let i = 0; i < sortedArr.length; i++) {
    bitmap = bitmap.or(ethers.BigNumber.from(sortedArr[i]).shl(i * 8))
  }
  return bitmap
}

const getBitmapTickets = (tickets) => {
  const array = []
  for (let i = 0; i < tickets.length; i++) {
    array.push(arrayToBitmap(tickets[i]))
  }
  return array
}

const Ticket = ({ numbers, index, onEdit }) => {
  const theme = useTheme()
  const validationTicket = JSON.parse(JSON.stringify(numbers))
  const repeatedNumbers = []
  const sortedTicket = validationTicket.sort()
  for (let i = 0; i < sortedTicket.length - 1; i++) {
    if (sortedTicket[i] === sortedTicket[i + 1]) {
      repeatedNumbers.push(sortedTicket[i])
    }
  }
  return (
    <Flex
      style={{
        marginBottom: 0,
        flexDirection: 'column',
        position: 'relative',
        width: '100%',
        maxWidth: 380,
        justifyContent: 'center',
        paddingLeft: 20,
        paddingRight: 20,
      }}
    >
      <Flex style={{ zIndex: 10, width: '100%' }}>
        <StyledSoftText style={{ flexGrow: 1, paddingTop: 14 }}>
          Ticket #{String(index + 1).padStart(3, '0')}
        </StyledSoftText>
      </Flex>
      <StyledHr style={{ width: '100%', borderStyle: 'dashed' }} />
      <Flex style={{ paddingBottom: 8, marginBottom: 16, zIndex: 10, gap: 4, justifyContent: 'center' }}>
        {Children.toArray(
          numbers.map((number, numberIndex) => (
            <StyledRoundedDigit style={{ position: 'relative' }}>
              <Input
                value={number}
                placeholder="0"
                style={{
                  width: '100%',
                  height: '100%',
                  background: number > 90 || number < 1 || repeatedNumbers.indexOf(number) >= 0 ? 'red' : 'transparent',
                  textAlign: 'center',
                  color: 'white',
                  fontSize: 14,
                  fontWeight: 700,
                  margin: 0,
                  padding: 0,
                  borderRadius: 120,
                }}
                onChange={(e) => {
                  try {
                    const value = e.target.value
                    if (value.match(/^[0-9]*$/)) {
                      onEdit(+value, index, numberIndex)
                    }
                  } catch (err) {
                    console.log(err)
                  }
                }}
              />
            </StyledRoundedDigit>
          )),
        )}
      </Flex>
      {theme.isDark ? (
        <svg
          style={{ position: 'absolute', zIndex: '1', left: '0%' }}
          width="100%"
          viewBox="0 0 352 124"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g filter="url(#filter0_bdi_1_1762)">
            <path
              d="M12 12C12 9.79086 13.7909 8 16 8H336C338.209 8 340 9.79086 340 12V43.2488C340 44.1562 339.691 45.0367 339.125 45.7456L337.5 47.7795C333.057 53.3408 332.822 61.1689 336.924 66.9866L339.269 70.3129C339.745 70.9874 340 71.7926 340 72.6179V104C340 106.209 338.209 108 336 108H16C13.7909 108 12 106.209 12 104V72.6815C12 71.8169 12.2802 70.9755 12.7986 70.2834L14.8143 67.5925C19.0735 61.9067 19.0735 54.0933 14.8143 48.4075L12.7986 45.7166C12.2802 45.0245 12 44.1831 12 43.3184V12Z"
              fill="url(#paint0_radial_1_1762)"
              fillOpacity="0.52"
              shapeRendering="crispEdges"
            />
            <path
              d="M12.5 12C12.5 10.067 14.067 8.5 16 8.5H336C337.933 8.5 339.5 10.067 339.5 12V43.2488C339.5 44.0428 339.23 44.8132 338.734 45.4335L337.109 47.4674C332.527 53.2025 332.285 61.2752 336.515 67.2747L338.86 70.601C339.277 71.1912 339.5 71.8957 339.5 72.6179V104C339.5 105.933 337.933 107.5 336 107.5H16C14.067 107.5 12.5 105.933 12.5 104V72.6815C12.5 71.925 12.7452 71.1887 13.1988 70.5832L15.2145 67.8923C19.6068 62.0288 19.6068 53.9712 15.2145 48.1077L13.1988 45.4168C12.7452 44.8113 12.5 44.075 12.5 43.3184V12Z"
              stroke="#3B496A"
              strokeOpacity="0.42"
              shapeRendering="crispEdges"
            />
          </g>
          <defs>
            <filter
              id="filter0_bdi_1_1762"
              x="0"
              y="-4"
              width="352"
              height="128"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feGaussianBlur in="BackgroundImageFix" stdDeviation="6" />
              <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_1_1762" />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset dy="4" />
              <feGaussianBlur stdDeviation="6" />
              <feComposite in2="hardAlpha" operator="out" />
              <feColorMatrix type="matrix" values="0 0 0 0 0.0584954 0 0 0 0 0.0778858 0 0 0 0 0.116667 0 0 0 0.12 0" />
              <feBlend mode="normal" in2="effect1_backgroundBlur_1_1762" result="effect2_dropShadow_1_1762" />
              <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_1_1762" result="shape" />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset dy="2" />
              <feGaussianBlur stdDeviation="2" />
              <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
              <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.04 0" />
              <feBlend mode="normal" in2="shape" result="effect3_innerShadow_1_1762" />
            </filter>
            <radialGradient
              id="paint0_radial_1_1762"
              cx="0"
              cy="0"
              r="1"
              gradientUnits="userSpaceOnUse"
              gradientTransform="translate(176 -117.833) rotate(90) scale(287.5 862.5)"
            >
              <stop stopColor="#364366" />
              <stop offset="1" stopColor="#273255" />
            </radialGradient>
          </defs>
        </svg>
      ) : (
        <svg
          style={{ position: 'absolute', zIndex: '1', left: '0%' }}
          width="100%"
          viewBox="0 0 352 124"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g filter="url(#filter0_bdi_1_2893)">
            <path
              d="M12 12C12 9.79086 13.7909 8 16 8H336C338.209 8 340 9.79086 340 12V43.2488C340 44.1562 339.691 45.0367 339.125 45.7456L337.5 47.7795C333.057 53.3408 332.822 61.1689 336.924 66.9866L339.269 70.3129C339.745 70.9874 340 71.7926 340 72.6179V104C340 106.209 338.209 108 336 108H16C13.7909 108 12 106.209 12 104V72.6815C12 71.8169 12.2802 70.9755 12.7986 70.2834L14.8143 67.5925C19.0735 61.9067 19.0735 54.0933 14.8143 48.4075L12.7986 45.7166C12.2802 45.0245 12 44.1831 12 43.3184V12Z"
              fill="url(#paint0_radial_1_2893)"
              fillOpacity="0.52"
              shapeRendering="crispEdges"
            />
            <path
              d="M12.5 12C12.5 10.067 14.067 8.5 16 8.5H336C337.933 8.5 339.5 10.067 339.5 12V43.2488C339.5 44.0428 339.23 44.8132 338.734 45.4335L337.109 47.4674C332.527 53.2025 332.285 61.2752 336.515 67.2747L338.86 70.601C339.277 71.1912 339.5 71.8957 339.5 72.6179V104C339.5 105.933 337.933 107.5 336 107.5H16C14.067 107.5 12.5 105.933 12.5 104V72.6815C12.5 71.925 12.7452 71.1887 13.1988 70.5832L15.2145 67.8923C19.6068 62.0288 19.6068 53.9712 15.2145 48.1077L13.1988 45.4168C12.7452 44.8113 12.5 44.075 12.5 43.3184V12Z"
              stroke="#EDEDED"
              strokeOpacity="0.42"
              shapeRendering="crispEdges"
            />
          </g>
          <defs>
            <filter
              id="filter0_bdi_1_2893"
              x="0"
              y="-4"
              width="352"
              height="128"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feGaussianBlur in="BackgroundImageFix" stdDeviation="6" />
              <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_1_2893" />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset dy="4" />
              <feGaussianBlur stdDeviation="6" />
              <feComposite in2="hardAlpha" operator="out" />
              <feColorMatrix type="matrix" values="0 0 0 0 0.0584954 0 0 0 0 0.0778858 0 0 0 0 0.116667 0 0 0 0.12 0" />
              <feBlend mode="normal" in2="effect1_backgroundBlur_1_2893" result="effect2_dropShadow_1_2893" />
              <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_1_2893" result="shape" />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset dy="2" />
              <feGaussianBlur stdDeviation="2" />
              <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
              <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.04 0" />
              <feBlend mode="normal" in2="shape" result="effect3_innerShadow_1_2893" />
            </filter>
            <radialGradient
              id="paint0_radial_1_2893"
              cx="0"
              cy="0"
              r="1"
              gradientUnits="userSpaceOnUse"
              gradientTransform="translate(176 -117.833) rotate(90) scale(287.5 862.5)"
            >
              <stop stopColor="#F5F6F8" />
              <stop offset="1" stopColor="#E8E8E8" />
            </radialGradient>
          </defs>
        </svg>
      )}
    </Flex>
  )
}

const BuyNowModal: React.FC<InjectedModalProps> = ({ onDismiss }) => {
  const theme = useTheme()
  const genericprovider = new ethers.providers.JsonRpcProvider('https://nd-699-384-776.p2pify.com/a0bb181b833e6a91efba0ec513109c50')
  const contractAddress = '0x043C2e5100A7157c36D677af0BbD62F76bB7E7D7'
  const busdAddress = '0x55d398326f99059ff775485246999027b3197955'

  const [quantity, setQuantity] = useState('')
  const [editNumbers, setEditNumbers] = useState(false)
  const [tickets, setTickets] = useState([])
  const [randomizeNumbers, setRandomizeNumbers] = useState(false)
  const [bottomClicked, setBottomClicked] = useState(false)
  const [BUSDBalance, setBUSDBalance] = useState(0)
  const [allowance, setAllowance] = useState(0)
  const [ticketPrice, setTicketPrice] = useState(0)
  const [total, setTotal] = useState(0)
  const [buying, setBuying] = useState(false)
  const [currentTimestamp, setCurrentTimestamp] = useState(0)
  const [invalidTicket, setInvalidTicket] = useState(false)

  const { account, library } = useWeb3React()

  const messagesEndRef = useRef(null)

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' })
  }

  const buyTickets = async (random) => {
    setBuying(true)
    try {
      if (random) {
        tickets.forEach((ticket, index) => {
          tickets[index] = getNewTicket()
        })
        setTickets(tickets)
        setInvalidTicket(false)
      }
      const busdContract = new ethers.Contract(busdAddress, abi, library.getSigner())
      if (allowance < total) {
        try {
          const tx = await busdContract.approve(
            contractAddress,
            '0x8000000000000000000000000000000000000000000000000000000000000000',
          )
          await tx.wait()
          setAllowance(total)
        } catch (err) {
          console.error(err)
          return
        }
      }

      const bitmapTickets = getBitmapTickets(tickets)
      const contract = new ethers.Contract(contractAddress, lotteryAbi, library.getSigner())
      const tx = await contract.functions.buyTickets(tickets.length, bitmapTickets)
      await tx.wait()
    } catch (err) {
      console.error(err)
    } finally {
      onDismiss()
      setBuying(false)
    }
  }

  useEffect(() => {
    genericprovider.getBlockNumber().then((blockNumber) => {
      genericprovider.getBlock(blockNumber).then((block) => {
        setCurrentTimestamp(block.timestamp)
      })
    })
  }, [])

  useEffect(() => {
    const busdContract = new ethers.Contract(busdAddress, abi, library.getSigner())
    busdContract.functions
      .allowance(account, contractAddress)
      .then((allowanceResp) => {
        setAllowance(+ethers.utils.formatUnits(allowanceResp[0]))
      })
      .catch((err) => {
        console.error(err)
      })
  }, [])

  useEffect(() => {
    const contract = new ethers.Contract(contractAddress, lotteryAbi, genericprovider)
    contract.functions.ticketPrice().then((ticketPriceResp) => {
      setTicketPrice(+ethers.utils.formatUnits(ticketPriceResp[0]))
    })
  }, [])

  useEffect(() => {
    setTotal(tickets.length * ticketPrice)
    if (bottomClicked) {
      scrollToBottom()
      setBottomClicked(false)
    }
  }, [tickets])

  const getBUSDTokenBalance = async (addr) => {
    const busdToken = new ethers.Contract(busdAddress, abi, library.getSigner())
    const busdBalance = await busdToken.balanceOf(addr)
    return busdBalance
  }

  useEffect(() => {
    if (account) {
      getBUSDTokenBalance(account).then((busdBalance) => {
        setBUSDBalance(+ethers.utils.formatUnits(busdBalance))
      })
    }
  }, [account])

  const getNewTicket = () => {
    const numbers = []
    const result = []
    for (let i = 1; i <= 90; i++) {
      numbers.push(i)
    }

    let i = 6
    let j
    while (i--) {
      j = Math.floor(Math.random() * (numbers.length - 1))
      result.push(numbers[j])
      numbers.splice(j, 1)
    }

    return result
  }

  useEffect(() => {
    if (randomizeNumbers) {
      const localTickets = tickets.slice()
      localTickets.forEach((ticket, index) => {
        localTickets[index] = getNewTicket()
      })
      setTickets(localTickets)
      setRandomizeNumbers(false)
      setInvalidTicket(false)
    }
  }, [randomizeNumbers])

  useEffect(() => {
    if (quantity !== '') {
      const amount = parseInt(quantity)
      const localTickets = tickets
      while (amount > localTickets.length) {
        localTickets.push(getNewTicket())
      }

      while (amount < localTickets.length) {
        localTickets.pop()
      }

      setTickets(localTickets)
      setTotal(localTickets.length * ticketPrice)
    }
  }, [quantity, tickets])

  const onEdit = (number, ticket, index) => {
    const localTickets = JSON.parse(JSON.stringify(tickets))
    localTickets[ticket][index] = number
    const validationTickets = JSON.parse(JSON.stringify(localTickets))
    setTickets(localTickets)

    let novalidticket = false

    // check number range
    validationTickets.forEach((tickete) => {
      tickete.forEach((numero) => {
        if (numero < 1 || numero > 90) {
          novalidticket = true
        }
      })
    })

    // check repeated numbers
    validationTickets.forEach((ticketete) => {
      const sortedTicket = ticketete.sort()
      for (let i = 0; i < sortedTicket.length - 1; i++) {
        if (sortedTicket[i] === sortedTicket[i + 1]) {
          novalidticket = true
        }
      }
    })
    setInvalidTicket(novalidticket)
  }

  return (
    <Modal
      title={editNumbers ? 'Edit Numbers' : 'Buy Now'}
      onBack={editNumbers ? () => setEditNumbers(false) : null}
      onDismiss={onDismiss}
    >
      {editNumbers ? (
        <ModalBody style={{ padding: 0 }}>
          <Flex flexDirection="column">
            <Flex mt="12px">
              <Text color={theme.colors.softTextColor} style={{ flexGrow: 1 }}>
                Total cost
              </Text>
              <Text>{total} USDT</Text>
            </Flex>
            <Text mt="16px" style={{ color: theme.colors.hardTextColor }}>
              Your Tickets {tickets.length ? `(${tickets.length})` : ''}
            </Text>
            <div style={{ marginTop: 20, height: 420, overflow: 'auto', textAlign: 'center' }}>
              <Button
                style={{
                  borderRadius: 160,
                  padding: 0,
                  margin: 0,
                  marginBottom: 12,
                  paddingBottom: 4,
                  paddingLeft: 2,
                  height: 32,
                  width: 32,
                  color: theme.isDark ? theme.colors.hardTextColor : 'white',
                  fontSize: 32,
                }}
                onClick={() => {
                  const newTickets = tickets.slice()
                  newTickets.push(getNewTicket())
                  setQuantity(newTickets.length.toString())
                  setTickets(newTickets)
                  setTotal(newTickets.length * ticketPrice)
                }}
                disabled={buying}
              >
                +
              </Button>
              {Children.toArray(
                tickets.map((ticket, index) => <Ticket onEdit={onEdit} index={index} numbers={ticket} />),
              )}
              {tickets.length > 2 ? (
                <Button
                  style={{
                    borderRadius: 160,
                    padding: 0,
                    margin: 0,
                    marginBottom: 12,
                    paddingBottom: 4,
                    paddingLeft: 2,
                    height: 32,
                    width: 32,
                    color: theme.isDark ? theme.colors.hardTextColor : 'white',
                    fontSize: 32,
                  }}
                  onClick={() => {
                    const newTickets = tickets.slice()
                    newTickets.push(getNewTicket())
                    setQuantity(newTickets.length.toString())
                    setTickets(newTickets)
                    setTotal(newTickets.length * ticketPrice)
                    setBottomClicked(true)
                  }}
                  disabled={buying}
                >
                  +
                </Button>
              ) : null}
              <div ref={messagesEndRef} />
            </div>
          </Flex>
          <Button
            onClick={() => buyTickets(false)}
            mt="32px"
            style={{
              borderRadius: '16px',
            }}
            disabled={buying || total === 0 || total > BUSDBalance || invalidTicket}
          >
            {total > allowance ? 'Approve' : 'Confirm'} and buy
          </Button>
          <Button
            mt="16px"
            mb="16px"
            onClick={() => setRandomizeNumbers(true)}
            style={{
              borderRadius: '16px',
              border: `2px solid ${theme.isDark ? theme.colors.primary : 'black'}`,
              color: theme.isDark ? 'white' : 'black',
              backgroundColor: 'transparent',
            }}
            disabled={buying}
          >
            Randomize your numbers
          </Button>
        </ModalBody>
      ) : (
        <ModalBody style={{ padding: 0 }}>
          <Flex justifyContent="center" flexDirection="column">
            <Text color={theme.colors.hardTextColor} mt="12px">
              Quantity
            </Text>
            <div style={{ position: 'relative', paddingLeft: 1, paddingRight: 1 }}>
              <Input
                placeholder="0"
                value={quantity}
                onChange={(e) => {
                  e.preventDefault()
                  try {
                    const value = e.target.value
                    if (value.match(/^[0-9]*$/)) {
                      setQuantity(value)
                    }
                  } catch (err) {
                    console.log(err)
                  }
                }}
                style={{
                  paddingLeft: '16px',
                  marginTop: '8px',
                  borderRadius: '8px',
                  backgroundColor: theme.colors.background,
                  color: theme.colors.hardTextColor,
                }}
              />
              <Box
                style={{
                  position: 'absolute',
                  right: '16px',
                  top: '22px',
                  color: total > BUSDBalance ? 'red' : theme.colors.softTextColor,
                  fontSize: '12px',
                }}
              >
                ${total}
              </Box>
            </div>
            <Flex mt="16px">
              <Text
                style={{
                  color: theme.colors.softTextColor,
                  fontSize: '12px',
                }}
              >
                Balance: {BUSDBalance.toFixed(0)} USDT
              </Text>
              <Button
                onClick={() => {
                  setQuantity(Math.floor(BUSDBalance / ticketPrice).toString())
                }}
                style={{
                  fontSize: '10px',
                  marginLeft: '8px',
                  padding: '4px 8px',
                  lineHeight: '12px',
                  height: '20px',
                  backgroundColor: theme.colors.maxButtonBackground,
                }}
                disabled={buying}
              >
                Max
              </Button>
            </Flex>
            <Flex mt="16px" width="100%">
              <Text
                style={{
                  color: theme.colors.softTextColor,
                  flexGrow: 1,
                }}
              >
                Cost
              </Text>
              <Text
                style={{
                  color: theme.colors.hardTextColor,
                }}
              >
                {quantity ? `${parseInt(quantity) * ticketPrice}` : '0'} USDT
              </Text>
            </Flex>
            <Button
              onClick={() => buyTickets(true)}
              mt="24px"
              style={{
                borderRadius: '16px',
              }}
              disabled={buying || tickets.length === 0}
            >
              Buy Randomized Tickets
            </Button>
            <Button
              mt="16px"
              mb="16px"
              onClick={() => setEditNumbers(true)}
              style={{
                borderRadius: '16px',
                border: `2px solid ${theme.isDark ? theme.colors.primary : 'black'}`,
                color: theme.isDark ? 'white' : 'black',
                backgroundColor: 'transparent',
              }}
              disabled={buying}
            >
              View/Edit Numbers
            </Button>
          </Flex>
        </ModalBody>
      )}
    </Modal>
  )
}

export default BuyNowModal
